export default {
  common: {
    projectList: "Liste des projets",
    pleaseInputProjectName: "Veuillez saisir le nom du projet",
    pipeline: "Pipeline",
    onhold: "En attente",
    win: "Gagné",
    loss: "Perdu",
    city: "Ville",
    amount: "Montant",
    winProbability: "Probabilité de gain",
    registeredOn: "Enregistré le",
    updatedOn: "Mis à jour le",
    thereAreNoMoreProjectsLeft: "Il n'y a plus de projets restants",

    drafting: "Brouillon",
    ready: "Prêt",
    shared: "Partagé",
    negotiating: "Négociation",
    secured: "Sécurisé",
    lost: "Perdu",
    onhold: "En attente",

    INITIAL: "Préparation du rapport ECM",
    ECM_REPORT_PREPARED: "Rapport ECM en attente de partage avec le client",
    ECM_TO_CUSTOMER: "Rapport ECM envoyé au client",
    CUSTOMER_KIV_PROPOSAL: "Proposition gardée en vue par le client",
    CUSTOMER_FUNDED: "Le client a confirmé le financement du projet",
    CUSTOMER_PROPOSAL: "Le client négocie la proposition",
    EA_TO_CUSTOMER: "Rapport EA envoyé au client",
    CUSTOMER_ORDERS: "Commandes du client",
    LOST_TO_COMPETITION: "Perdu face à la concurrence",
    STATUS_PROJECT: "Statut rapporté dans un autre projet",
    IN_ACTIVE: "Projet en attente",
    getProjectInfoFailed: "Échec de l'obtention des informations du projet",
    getCitylistFailed: "Échec de l'obtention de la liste des villes",
    cantGetProjectDetails: "Impossible d'obtenir les détails du projet",
    noProjectId: "Aucun ID de projet",
    noProjectState: "Aucun état de projet",
    enterProjectName: "Saisissez le nom du projet",
    noActualEcmQuoted: "ECM réel non référencé"
  },
  projectDlg: {
    newProject: "Nouveau projet",
    projectName: "Nom du projet",
    projectState: "État du projet",
    customer: "Client",
    address: "Adresse",
    customerEmail: "E-mail du client",
    auditDate: "Date d'audit",
    jobsiteCity: "Ville du chantier",
    estimatedEcmQuoted: "Estimation du prix proposé pour l'ECM",
    exceptedOrder: "Date prévue de commande",
    winProbability: "Probabilité de gain (%)",
    saveRetrun: "Enregistrer & Retourner",
    saveAudit: "Enregistrer & Auditer",
    statusRemarks: "Remarques sur le statut",

    actualEcmQuoted: "Offres ECM réelles",
    actualOrder: "Date réelle de la commande"
  }
}



// WEBPACK FOOTER //
// ./src/locale/projectList/fr.js